import { Box, Icon, Text, Heading } from '@medely/ui-kit';
import React from 'react';
import { JobDetailsListItem } from '../JobDetailsListItem';
import { ShiftLocation } from '../ShiftLocation';
import { ShiftDate } from '../ShiftDate';
import DisplayHelpers from '../../../utils/displayHelpers';
import { HideFrom } from '@mp/components/HideFrom';
import { ExtendedRateInfo } from '@mp/components/shared/ExtendedRateInfo';
import { ProfessionalTerms } from '../ProfessionalTerms';
import { CovidProtocol } from '../CovidProtocol';
import { PreBookConfirmationInfoProps } from './interface';
import { parseFragmentData } from '@mp/graphql/generated';
import { JobDetailsFragment } from '../jobDetailsComponents/graphql';
import { useCurrentUser } from '@mp/hooks';
import { COVID_REQUIREMENTS } from '@mp/constants';

export const PreBookConfirmationInfo = ({
  job: inputJob,
  userCoordinates,
}: PreBookConfirmationInfoProps) => {
  const job = parseFragmentData(JobDetailsFragment, inputJob);

  const { isAgency, isSaas } = useCurrentUser();

  const covidText =
    COVID_REQUIREMENTS.confirmation[
      job?.location?.covid_requirement as keyof typeof COVID_REQUIREMENTS.confirmation
    ] ?? '';

  const showXRInfo = !(isAgency || isSaas);

  return (
    <>
      <Box py={1.5}>
        <JobDetailsListItem
          icon={<Icon name="light-location-dot" variant="custom" />}
          title="Location"
        >
          <ShiftLocation
            job={inputJob}
            bookVariant="pre-book"
            distanceVariant="local"
            userCoordinates={userCoordinates}
          />
        </JobDetailsListItem>
      </Box>
      <Box py={1}>
        <JobDetailsListItem icon={<Icon name="light-calendar" variant="custom" />} title="Date">
          <ShiftDate job={inputJob} displayStartingSoonBadge />
        </JobDetailsListItem>
      </Box>
      <Box py={1}>
        <JobDetailsListItem icon={<Icon name="light-clock" variant="custom" />} title="Shift time">
          <Text size="m">
            {DisplayHelpers.job.time({
              current_starts_time: job?.current_starts_time,
              current_ends_time: job?.current_ends_time,
              approved_clock_in: job?.approved_clock_in,
              approved_clock_out: job?.approved_clock_out,
              guaranteed_minimum_hours: job?.guaranteed_minimum_hours,
              status: job?.status,
              shift_type: job?.shift_type,
              assignment: job?.assignment,
              location: job?.location,
              options: { scheduledShiftStyle: true },
            })}
          </Text>
        </JobDetailsListItem>
      </Box>
      <HideFrom saas agency>
        {showXRInfo && (
          <Box py={1}>
            <ExtendedRateInfo
              icon={<Icon name="light-calendar-clock" variant="custom" />}
              job={inputJob}
            />
          </Box>
        )}
      </HideFrom>
      <HideFrom saas>
        <Box py={2}>
          <ProfessionalTerms />
        </Box>
      </HideFrom>
      {!!job?.location?.covid_requirement && !!covidText && (
        <CovidProtocol description={covidText} />
      )}
      {job?.detail && (
        <Box py={1}>
          <Heading size="s">Additional details</Heading>
          <Box pt={1.5}>
            <Text size="m">{job?.detail}</Text>
          </Box>
        </Box>
      )}
    </>
  );
};
